import { render } from "./trash.vue?vue&type=template&id=d1086a6a"
import script from "./trash.js?vue&type=script&lang=js&external"
export * from "./trash.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__